export default __webpack_public_path__ + "static/media/star-line.56a7dbe5.svg";